module.exports = __webpack_public_path__ + "img/tenge-sign.0c29bd3e.svg";